module.exports = __webpack_public_path__ + "img/switzerland-ill-defined-causes-female.be5c9194.png";